<template>
    <modal name="subscription-video-modal" width="100%" height="100%" :clickToClose="false">
        <div class="modal-wrapper">
          <video class="video-box" controls autoplay>
            <source src="/static/videos/readtheory_why_premium.mp4" type="video/mp4">
            Your browser does not support the video tag.
          </video>
            <primary-button class="btn-choose" @click="showPlanSection">Choose your plan</primary-button>
            <a class="btn-close" @click="closeModal">
                <rt-picture src="/assets/app/class/icon-close-white.svg"/>
            </a>
        </div>
    </modal>
</template>

<script>

import Vue from 'vue';
import Embed from 'v-video-embed';
import PrimaryButton from '../../common/PrimaryButton.vue';
import RtPicture from '../../common/Picture.vue';
Vue.use(Embed);

export default {
  props: ['show'],
  components: {
    PrimaryButton,
    RtPicture
  },
  watch: {
    'show'(newVal) {
      if (newVal) {
        this.$modal.show('subscription-video-modal');
      }
    }
  },
  methods: {
    closeModal() {
      this.$modal.hide('subscription-video-modal');
	  this.$emit('close');
	},
	showPlanSection() {
	  this.$modal.hide('subscription-video-modal');
	  this.$emit('onShowPlan');
	}
  }
}
</script>

<style lang="scss" scoped>

@import '../../common/variables';

.v--modal-overlay {
  z-index: 9999999999;
  .modal-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    width: 100%;
    height: 100%;
    background: #132C55;
    position: relative;
    ::v-deep(.embed-responsive) {
      width: 830px;
      height: 469px;
    }
    .video-box {
      width: 720px;
    }
    .btn-choose {
      background: #EE7D54;
      margin-top: 48px;
      padding: 16px 45px;
      border: 0;
      font-size: 16px;
      color: #fff;
    }
    .btn-close {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      position: absolute;
      top: 56px;
      right: 56px;
      background: rgba(238, 245, 255, 0.22);
      border-radius: 50%;
      cursor: pointer;
    }
  }
  @media(max-width: 767px) {
    .modal-wrapper {
      ::v-deep(.embed-responsive) {
        width: 100%;
        height: 100%;
      }
      .video-box {
        width: 80%;
      }
    }
  }
}



</style>

